export default "__VITE_ASSET__C10LUWo5__"